import DynamoDB from 'aws-sdk/clients/dynamodb';
import { Notification } from '../interfaces/backend/Notification';

export const getNotification = async (
  accountId: string,
  notificationId: string
): Promise<Notification | null> => {
  const ddb = new DynamoDB.DocumentClient();
  const item = await ddb
    .get({
      Key: {
        envId: accountId,
        notificationId
      },
      TableName: 'notificationsTable5'
    })
    .promise();
  return item.Item ? (item.Item as Notification) : null;
};

export const putNotification = async (
  notification: Notification
): Promise<void> => {
  const ddb = new DynamoDB.DocumentClient();
  await ddb
    .put({
      TableName: 'notificationsTable5',
      Item: notification
    })
    .promise();
};
